<div class="p-3 dw-approval">
  <div class="d-flex flex-row align-items-center justify-content-between">
    <h3 class="mb-0">Approve / Reject Deposit &amp; Withdraw</h3>
    <button class="btn btn-sm" (click)="close()">CLOSE</button>
  </div>
  <p class="text-muted mb-2" *ngIf="setPlayer">Player: <b>{{ setPlayer.code }}</b></p>
  <hr />

  <div *ngIf="is_loading" class="text-muted py-3">Loading…</div>

  <div *ngIf="!is_loading">

    <!-- ===== Pending Deposits ===== -->
    <h5 class="mb-2">Pending Deposit <span class="badge bg-secondary">{{ deposits.length }}</span></h5>
    <div class="table-responsive mb-4">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Amount</th>
            <th>Proof</th>
            <th>Action</th>
            <th>Bank</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deposit of deposits">
            <td style="min-width: 110px;">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="deposit.amount">
            </td>
            <td>
              <img *ngIf="deposit.file" [src]="'/storage' + deposit.file" alt="proof"
                   style="max-width: 70px; border-radius: 4px;">
            </td>
            <td style="min-width: 120px;">
              <select class="form-select form-select-sm" [(ngModel)]="deposit.status">
                <option [ngValue]="1">Approve</option>
                <option [ngValue]="0">Reject</option>
              </select>
            </td>
            <td style="min-width: 160px;">
              <select class="form-select form-select-sm" [(ngModel)]="deposit.bank_id" *ngIf="deposit.status == 1">
                <option *ngFor="let bank of banks" [ngValue]="bank.id">{{ bank.title }} - {{ bank.payee }} - {{ bank.account }}</option>
              </select>
            </td>
            <td class="text-nowrap small">{{ deposit.create_on | date:'dd/MM HH:mm' }}</td>
            <td>
              <button class="btn btn-primary btn-sm" [disabled]="deposit._submitting || deposit.is_suspended == 1" (click)="updateDeposit(deposit)">
                {{ deposit._submitting ? '...' : (deposit.status == 1 ? 'APPROVE' : 'REJECT') }}
              </button>
            </td>
          </tr>
          <tr *ngIf="deposits.length == 0">
            <td colspan="100%" class="text-center text-muted py-3" style="font-style: italic;">No pending deposit</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ===== Pending Withdrawals ===== -->
    <h5 class="mb-2">Pending Withdraw <span class="badge bg-secondary">{{ withdraws.length }}</span></h5>
    <div class="table-responsive">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Payee</th>
            <th>Amount</th>
            <th>Bank Account</th>
            <th>Action</th>
            <th>Payout</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let withdraw of withdraws">
            <td style="min-width: 120px;">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="withdraw.fullname">
            </td>
            <td style="min-width: 130px;">
              <ng-container *ngIf="allow_edit_balance">
                <div class="input-group input-group-sm flex-nowrap">
                  <input type="number" step="0.01" min="0" [max]="withdraw.max_amount"
                         class="form-control form-control-sm" [(ngModel)]="withdraw.amount" (blur)="clampAmount(withdraw)">
                  <button type="button" class="btn btn-outline-secondary" (click)="trimAmount(withdraw)"
                          title="Trim down to the nearest lower {{trim_step}}">.00</button>
                </div>
                <small class="text-muted">Max: {{ withdraw.max_amount | number: '1.2-2' }}</small>
              </ng-container>
              <span *ngIf="!allow_edit_balance">{{ withdraw.amount | number: '1.2-2' }}</span>
            </td>
            <td class="small">{{ withdraw.bank_name }}<br>{{ withdraw.bank_account }}</td>
            <td style="min-width: 120px;">
              <select class="form-select form-select-sm" [(ngModel)]="withdraw.status">
                <option [ngValue]="1">Approve</option>
                <option [ngValue]="0">Reject</option>
              </select>
            </td>
            <td style="min-width: 170px;">
              <ng-container *ngIf="withdraw.status == 1">
                <select class="form-select form-select-sm" [(ngModel)]="withdraw.bank_id" (change)="changeBank(withdraw)">
                  <option *ngFor="let bank of banks" [ngValue]="bank.id">{{ bank.title }} - {{ bank.payee }} - {{ bank.account }} {{ bank.auto ? '(Auto)' : '(Manual)' }}</option>
                </select>
                <div class="mt-2" *ngIf="withdraw.bank_id && !withdraw.is_auto">
                  <input type="file" accept="image/*" class="form-control form-control-sm" (change)="uploadFile($event, withdraw)">
                  <img [src]="withdraw.file" class="img-fluid mt-1" style="max-width: 90px;" *ngIf="withdraw.file">
                </div>
              </ng-container>
            </td>
            <td class="text-nowrap small">{{ withdraw.create_on | date:'dd/MM HH:mm' }}</td>
            <td>
              <button class="btn btn-primary btn-sm" [disabled]="withdraw._submitting || withdraw.is_suspended == 1" (click)="updateWithdraw(withdraw)">
                {{ withdraw._submitting ? '...' : (withdraw.status == 1 ? 'APPROVE' : 'REJECT') }}
              </button>
            </td>
          </tr>
          <tr *ngIf="withdraws.length == 0">
            <td colspan="100%" class="text-center text-muted py-3" style="font-style: italic;">No pending withdraw</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
